import { getUrlApi } from './fetcher'

function getWhitelistHostname() {
  const { hostname: hostnameWindow } = new URL(window.location.origin)
  const whitelist = [hostnameWindow]

  const urlApi = getUrlApi()
  if (!urlApi.startsWith('/')) {
    // review apps
    const { hostname: hostnameApi } = new URL(urlApi)
    whitelist.push(hostnameApi)
  }

  return whitelist
}

function validate(url) {
  const whitelist = getWhitelistHostname()
  try {
    const urlObject = new URL(url)
    const { hostname, protocol } = urlObject

    if (protocol !== 'https:') return false
    if (!whitelist.includes(hostname)) return false
    return true
  } catch (e) {
    // new URL will throw an error if the url is invalid
    return false
  }
}

function getAbsoluteUrl({ url }) {
  if (url.startsWith('/')) {
    return `${window.location.origin}${url}`
  } else {
    return url
  }
}

export function safeAssignUrl({ url, throwInvalid = false }) {
  const absoluteUrl = getAbsoluteUrl({ url })
  if (validate(absoluteUrl)) {
    return window.location.assign(absoluteUrl)
  } else if (throwInvalid) {
    throw new Error(`Invalid url ${url}`)
  }
}

export function isValidUrl(string) {
  try {
    new URL(string)
    return true
  } catch (err) {
    return false
  }
}

const HTTP_PROTOCOLS = ['http:', 'https:']

export function parseHttpUrl(value) {
  try {
    const url = new URL(value)
    return HTTP_PROTOCOLS.includes(url.protocol) ? url : null
  } catch {
    return null
  }
}

export function isValidHttpUrl(value) {
  return parseHttpUrl(value) !== null
}

function normalizeDomain(domain) {
  if (!domain) return ''
  const trimmed = String(domain).trim().toLowerCase()
  const host = trimmed.includes('//') ? (parseHttpUrl(trimmed)?.hostname ?? '') : trimmed.split('/')[0]
  return host.replace(/\.$/, '')
}

// Same as the function used in DRAFT-PRODUCTS-UPSERTED Miniapp pivot data csv check
// keep in sync with that function to avoid false positives/negatives
export function isUrlWithinDomain(value, domain) {
  const url = parseHttpUrl(value)
  const normalizedDomain = normalizeDomain(domain)
  if (!url || !normalizedDomain) return false
  const hostname = url.hostname.toLowerCase()
  return hostname === normalizedDomain || hostname.endsWith(`.${normalizedDomain}`)
}

// Encode the query string of images.nfinite.app bucket URLs to avoid issues with special characters (images with ?guid=... in object name)
export function encodeImagesBucketQueryString(fullUrl) {
  if (!fullUrl) return fullUrl
  if (!fullUrl.startsWith('https://images.nfinite.app')) return fullUrl
  const [base, query] = fullUrl.split('?')
  if (!query) return fullUrl
  const encodedQuery = encodeURIComponent('?' + query)
  return base + encodedQuery
}
